import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/partner/OnboardingWelcome.css";

export default function OnboardingComplete({completed=false}) {
  const navigate = useNavigate();

  const [checks, setChecks] = useState({
    commission: false,
    payment: false,
    guidelines: false,
    stripe: completed,
  });

  const allChecked = Object.values(checks).every(Boolean);

  function updateCheck(name) {
    setChecks((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  }

  function finish() {
    // Save onboarding completed in backend here
    navigate("/dashboard");
  }

  return (
    <div className="onboarding-complete">
      <h1>Partner Agreement</h1>

      <div className="agreements">
        <label className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={checks.commission}
            onChange={() => updateCheck("commission")}
          />
          <span className="form-check-label">
            I understand this is a commission-only position.
          </span>
        </label>

        <label className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={checks.payment}
            onChange={() => updateCheck("payment")}
          />
          <span className="form-check-label">
            I understand commissions are paid only after client payments are
            successfully collected.
          </span>
        </label>

        <label className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={checks.guidelines}
            onChange={() => updateCheck("guidelines")}
          />
          <span className="form-check-label">
            I agree to follow South Central Development's Partner Guidelines.
          </span>
        </label>

        <label className="form-check form-check-disabled">
          <input
            type="checkbox"
            className="form-check-input"
            checked={checks.stripe}
            onChange={() => updateCheck("stripe")}
            disabled
          />
          <span className="form-check-label">
            I have completed my Stripe setup.
          </span>
        </label>
      </div>

      <div className="actions">
        <button
          className="btn btn-secondary"
          onClick={() => navigate("/onboarding/stripe")}
        >
          Back
        </button>

        <button
          className="btn btn-success"
          disabled={!allChecked}
          onClick={finish}
        >
          Complete Onboarding
        </button>
      </div>
    </div>
  );
}